import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import academicStoryReducer from "./academicStory/academicStory";
import adminSettingsReducer from "./adminSettings/adminSettings";
import AreasReducer from "./descriptorsProfiles/areas/areas";
import areasReducer from "./areasfuncional/areas";
import authReducer from "./auth/auth";
import beneficersReducer from "./securityBeneficers/securityBeneficers";
import bienvenidaReducer from "./on&offBoarning/Mantenimientos/bienvenida/bienvenida";
import CAMPAÑAReducer from "./climalaboral/campaña/campaña";
import CapacitacionOnBoardingReducer from "./on&offBoarning/capacitacion/capacitacion";
import CasualtyMonitorReducer from "./Modulo_Sanciones/Casualty_Monitor/casualty_monitor";
import categoryReducer from "./climalaboral/category/category";
import centerCostReducer from "./centercost/centercost";
import checkListReducer from "./checklist/checklist";
import civilStateReducer from "./civilstate/civilstate";
import classificationReducer from "./Classification/classification";
import collegeDegreeReducer from "./collegedegree/collegedegree";
import companiaReducer from "./compania/compania";
import CompetenciesReducer from "./descriptorsProfiles/competencies/competencies";
import CompetenciesTypeReducer from "./descriptorsProfiles/CompetenciesType/CompetenciesType";
import currentSituationReducer from "./currentSituation/currentSituation";
import DashBoardRespBossReducer from "./on&offBoarning/dashboardJefeResp/dashboardJefeResp";
import DescCompetenciesReducer from "./descriptorsProfiles/descCompetencies/descCompetencies";
import diagnosisReducer from "./diagnosis/diagnosis";
import DisciplinaryActionsReducer from "./Modulo_Sanciones/Disciplinary_Actions/disciplinary_actions";
import DisciplinaryActionTypesReducer from "./Modulo_Sanciones/Disciplinary_Action_Types/disciplinary_action_types";
import DisciplinaryCaseReducer from "./Modulo_Sanciones/diciplinarycase/disciplinary_case";
import DisciplinaryMeasurementReducer from "./Modulo_Sanciones/Disciplinary_Measurement/disciplinary_measurement";
import DisciplinaryReasonReducer from "./Modulo_Sanciones/Disciplinary_Reason/disciplinary_reason";
import divisionPersonalReducer from "./divisionPersonal/divisionPersonal";
import divisionReducer from "./division/division";
import educationReducer from "./education/education";
import emergencyContactReducer from "./emergencycontact/emergencyContact";
import employeeDocsCheckListReducer from "./employeeDocsChecklist/employeeDocsChecklist";
import employeesHierarchyReducer from "./employeesHierarchy/employeesHierarchy";
import employeesReducer from "./employees/employees";
import employeesTimesReducer from "./employeesTimes/employeesTimes";
import employmentRelationShipFuncionalReducer from "./employmentrelationShipFuncional/employmentrelationShip";
import equipmentReducer from "./equipmentAsig/equipmentAsig";
import FoulTypeReducer from "./Modulo_Sanciones/Foul_Type/foul_type";
import funcFormationsReducer from "./func_formacion/funcFormacion";
import funcStructureReducer from "./funcionalstructure/funcStructure";
import funcTabEmployeedReducer from "./func_ficha_empleados/funcTabEmployeed";
import gestorDocumentalReducer from "./gestorDocumental/gestorDocumental";
import healthReducer from "./health/health";
import instituteReducer from "./institute/institute";
import jobPositionsReducer from "./jobposition/jobPosition";
import jobsReducer from "./jobs/jobs";
import jobStoryReducer from "./jobStory/jobStory";
import labsReducer from "./laboratories/laboratories";
import measurementsReducer from "./climalaboral/measurements/measurements";
import MeasurementUnitReducer from "./descriptorsProfiles/MeasurementUnit/MeasurementUnit";
import monitorOnBoarding from "./on&offBoarning/monitor/monitor";
import monitorReducer from "./climalaboral/monitor/monitor";
import orgsPruebaReducer from "./pruebaDashboard/organization/organization";
import orgsReducer from "./organization/organization";
import plantillaCuestionarioReducer from "./climalaboral/plantillaCuestionario/plantillaCuestionario";
import plazasJefesReducer from "./dashboardPlazasJefes/plazasJefes";
import PoliticsAndProceduresReducer from "./descriptorsProfiles/PoliticsAndProcedures/PoliticsAndProcedures";
import preguntaReducer from "./climalaboral/TipoPregunta/TipoPregunta";
import PurposeReducer from "./descriptorsProfiles/Purpose/Purpose";
import relationshipReducer from "./relationship/relationship";
import relativesReducer from "./relatives/relatives";
import ReporteLoginReducer from "./reporteLogin/reporteLogin";
import SancionesStatusReducer from "./Modulo_Sanciones/status/status";
import segmentReducer from "./climalaboral/segment/segmento";
import specializationReducer from "./specialization/specialization";
import SurveyReducer from "./climalaboral/Encuestas/encuestas";
import tasksReducer from "./tasks/tasks";
import thunk from "redux-thunk";
import toolReducer from "./climalaboral/tool/tool";
import unidadNodesReducer from "./Aurora/unidaNode/unidadNode";
import UnlinkCategoriesReducer from "./Modulo_Sanciones/Unlink_Categories/unlink_categories";
import UnlinkTemplatesReducer from "./Modulo_Sanciones/Unlink_Templates/unlink_templates";
import updateDependantsDataReducer from "./updateDependantsData/updateDependantsData";
import updateUserDataReducer from "./updateUserData/updateUserData";
import vaccinesEmpReducer from "./vaccinesEmployees/vaccinesEmployees";
import vaccinesReducer from "./vaccines/vaccines";
import WFlowEmpleadosReducer from "./on&offBoarning/Mantenimientos/WorkFlowEmp/wFlowEmpleados";
import workflowBlockCheckListReducer from "./on&offBoarning/checklistTareas/WorkFlowBlockCheckList";
import workflowBlockReducer from "./on&offBoarning/workflowbock/workflowblock";
import workflowReducer from "./on&offBoarning/workflow/workflow";
import CompetenciesDescReducer from "./descriptorsProfiles/competenciesDesc/competenciesDesc";
import SancionesDocsReducer from "./Modulo_Sanciones/formatos/formatos";
import GeneralInfoReducer from "./descriptorsProfiles/GeneralInfo/GeneralInfo";
import TitlesReducer from "./descriptorsProfiles/Titles/Titles";
import KnowledgeAreasReducer from "./descriptorsProfiles/KnowledgeAreas/KnowledgeAreas";
import EducationLevelReducer from "./descriptorsProfiles/EducationLevel/EducationLevel";
import CourseReducer from "./descriptorsProfiles/Courses/Courses";
import TechnicalKnowledgeReducer from "./descriptorsProfiles/TechnicalKnowledge/TechnicalKnowledge";
import MantIndkReducer from "./descriptorsProfiles/mantIndik/mantIndk";
import generalData from "./descriptorsProfiles/GeneralData/GeneralData";
import JobFunctionReducer from "./descriptorsProfiles/JobFunction/JobFunction";
import IndikatorsReducer from "./descriptorsProfiles/indikators/indikators";
import PreparationReducer from "./descriptorsProfiles/Preparation/Preparation";
import TrainingReducer from "./descriptorsProfiles/Formation/Formation";
import TechnicalKnowledgeAcquiredReducer from "./descriptorsProfiles/TechnicalKnowledgeAcquired/TechnicalKnowledgeAcquired";
import ExperienceReducer from "./descriptorsProfiles/Experience/Experience";
import AssignCompetenciesReducer from "./descriptorsProfiles/assignCompetencies/assignCompetencies";
import PlazasVacantesReducer from "./seleccionContratacion/plazas_vacantes/plazas_vacantes";
import EstadosReducer from "./seleccionContratacion/estados/estados";
import MotivosReducer from "./seleccionContratacion/motivo/motivos";
import PaisesReducer from "./seleccionContratacion/pais/paises";
import CompetenciesTotalReducer from "./descriptorsProfiles/TotalCompetence/TotalCompetence";
import RequirementsMonitorReducer from "./seleccionContratacion/RequirementsMonitor/RequirementsMonitor";
import DashBoardSelectReducer from "./seleccionContratacion/dashboardSeleccionContratacion/dashboardSelecResp";
import RequestTrackingReducer from "./seleccionContratacion/RequestTracking/RequirementsMonitor";
import EvaluationTypeReducer from "./evaluacion_desempenio/EvaluationType/EvaluationType";
import PeriodoEvaluacionReducer from "./evaluacion_desempenio/periodo_evaluacion/periodoEvaluacion";
import DashBoardSelectContratacionesReducer from "./seleccionContratacion/dashboardSeleccionContratacion/contrataciones/dashboardSelecContrataciones";
import DashBoardSelectVacantesReducer from "./seleccionContratacion/dashboardSeleccionContratacion/vacantes/dashboardSelecVacantes";
import MetricByFactorReducer from "./evaluacion_desempenio/MetricByFactor/MetricByFactor";
import FactorReducer from "./evaluacion_desempenio/Factor/Factor";
import FactorQuestionReducer from "./evaluacion_desempenio/FactorQuestion/FactorQuestion";
import FactorTemplateReducer from "./evaluacion_desempenio/FactorTemplate/FactorTemplate";
import PlanAccionReducer from "./evaluacion_desempenio/plan_accion/planAccion";
import CategoriaDesempenioReducer from "./evaluacion_desempenio/categorias_desempenio/categoriaDesempenio";
import PeriodicityReducer from "./evaluacion_desempenio/Periodicity/Periodicity";
import MetricaCompetenciaReducer from "./evaluacion_desempenio/metricaCompetencia/metricaCompetencia";
import PeriodConfigReducer from "./evaluacion_desempenio/PeriodConfig/PeriodConfig";
import PesoCompetenciaReducer from "./evaluacion_desempenio/pesoCompetencia/pesoCompetencia";
import PlantillaCompetenciaReducer from "./evaluacion_desempenio/CompetencyTemplate/plantillaCompetencia";
import EvaluationMonitorReducer from "./evaluacion_desempenio/EvaluationMonitor/EvaluationMonitor";
import CompetencyQuestionReducer from "./evaluacion_desempenio/competencyEvaluationQuestions/competencyQuestions";
import EvalFormCompetencyReducer from "./evaluacion_desempenio/FormularioEval_Competencia/eval_form_competency";
import EmployeeMonitorReducer from "./evaluacion_desempenio/EmployeeMonitor/EmployeeMonitor";
import EvalFormCompetencyQuestionReducer from "./evaluacion_desempenio/formularioEval_Comp_Question/eval_form_competency_questions";
import OverviewReducer from "./evaluacion_desempenio/Overview/Overview";
import EvalFormFactorReducer from "./evaluacion_desempenio/formularioEval_Factor/eval_form_factor";
import DashboardJefeReducer from "./evaluacion_desempenio/DashboardJefe/DashboardJefe";
import NotificationsReducer from "./notifications/notifications";
import ModalitiesReducer from "./capacitacionDesarrollo/modalities/modalities";
import TrainingTypeReducer from "./capacitacionDesarrollo/trainng_type/trainingType";
import OriginsReducer from "./capacitacionDesarrollo/origins/origins";
import ReasonsForAbsenceReducer from "./capacitacionDesarrollo/reasons_for_absence/reansons_for_absence";
import TrainingsReducer from "./capacitacionDesarrollo/trainings/trainings";
import MatrixNineBoxesReducer from "./capacitacionDesarrollo/matrix_nine_boxes/matrixNineBoxes";
import StatusReducer from "./capacitacionDesarrollo/State/State";
import MetricEvaluationFactorReducer from "./capacitacionDesarrollo/MetricEvaluationFactor/MetricEvaluationFactor";
import MetricNineBoxesReducer from "./capacitacionDesarrollo/MetricNineBoxes/MetricNineBoxes";
import FormalEducationMetricsReducer from "./capacitacionDesarrollo/formal_education_metrics/formalEducationMetrics";
import MetricJobExperienceReducer from "./capacitacionDesarrollo/MetricJobExperience/MetricJobExperience";
import ApproachesReducer from "./capacitacionDesarrollo/approaches/approaches";
import CampaignsReducer from "./capacitacionDesarrollo/campaigns/campaigns";
import TrainingEventsReducer from "./capacitacionDesarrollo/TrainingEvents/TrainingEvents";
import EmployeeMonitorCapacitationReducer from "./capacitacionDesarrollo/EmployeeMonitor/EmployeeMonitor";
import TrainingAssistanceReducer from "./capacitacionDesarrollo/Training_assistance/trainingAssistance";
import DetailTrainingReducer from "./capacitacionDesarrollo/DetailTraining/detailTraining";
import NineBoxesReducer from "./capacitacionDesarrollo/NineBoxes/NineBoxes";
import CountryUserReducer from "./countryUser/countryUser";
import DepartamentUserReducer from "./departamentUser/departamentUser";
import MunicipalityUserReducer from "./municipalityUser/municipalityUser";
import HolidayReducer from "./holidays/holidays";
import JobpositionRelatedReducer from "./jobpositionRelated/jobpositionRelated";
import FactorNameReducer from "./evaluacion_desempenio/FactorName/FactorName";
import FormEvalCapaReducer from "./capacitacionDesarrollo/formEvalCapa/FormEvalCapa";
import PositionHistoryReducer from "./positionHistory/positionHistory";
import EvaluationAcceptReducer from "./evaluacion_desempenio/EvaluationAccept/EvaluationAccept";
import WorkflowTaskListReducer from "./on&offBoarning/workFlowTaskList/workflowTaskList";
import ExcelMassiveUploadReducer from "./Headcount/ExcelMassiveUpload/ExcelMassiveUpload";
import descriptorValidationReducer from "./descriptorsProfiles/DescriptorValidation/DescriptorValidation";
import SessionNotificationReducer from "./Headcount/SessionNotification/SessionNotification";
import CriteriosEvaluadorReducer from "./evaluacion_desempenio/Evaluator_criteria/evaluatorCriteria";
import CollaboratorsEvaluateReducer from "./evaluacion_desempenio/CollaboratorsToEvaluate/collaboratorsEvaluate";
import ActivoFijoReducer from "./Headcount/ActivoFijo/ActivoFijo";
import ExcelUploadReducer from "./evaluacion_desempenio/cargaArchivosExcel/ExcelUpload";
import ClimaLogReducer from "./climalaboral/climaLog/climaLog";
import GoalPerYearReducer from "./capacitacionDesarrollo/goalPerYear/goalPerYear";
import cuestionarioReducer from "./climalaboral/cuestionario/cuestionario";
import TipoCriticidadReducer from "./Carrera_Sucesion/TipoCriticidad/TipoCriticidad";
import CursosReducer from "./Carrera_Sucesion/Cursos/Courses";
import CursosFuncionReducer from "./Carrera_Sucesion/CursosFunciones/CoursesFun";
import CriticidadReducer from "./Carrera_Sucesion/Criticidad/Criticidad";
import FactoresCriticidadReducer from "./Carrera_Sucesion/FactoresCriticidad/FactoresCriticidad";
import MatrizEvaluacionPuestoReducer from "./Carrera_Sucesion/MatrizEvaluacionPuesto/MatrizEvaluacionPuesto";
import authBoarningReducer from "./on&offBoarning/auth/authBoarning";
import MatrizSucesionReducer from "./Carrera_Sucesion/MatrizSucesion/MatrizSucesion";
import EvaluableEmployeeMonitorReducer from "./capacitacionDesarrollo/evaluable_employee_monitor/evaluableEmployeeMonitor";
import EmployeesVacationsReducer from "./vacations/employees_vacations/employeesVacations";
import CalendarEmployeeEventsReducer from "./vacations/calendar_employee_events/calendar";
import CalendarHolidaysReducer from "./vacations/calendar_holidays/calendarHolidays";
import CriteriosReducer from "./Carrera_Sucesion/Criterios/Criteria";
import FactoresCriteriosReducer from "./Carrera_Sucesion/FactoresCriterios/FactorsCriteria"
import FactoresResponsablesReducer from "./Carrera_Sucesion/FactoresResponsables/ResponsiblesFactors";
import DescriptorFactoresCriterios from "./descriptorsProfiles/FactoresCriterios/factorsCriteria"
import PlanCarreraIndividualReducer from "./Carrera_Sucesion/PlanCarreraIndividual/PlanCarreraIndividual"
import ScheduleTrackingPlannedVacationsEmployeeReducer from "./vacations/schedule_tracking_planned_vacations_employee/scheduleTrackingPlannedVacationsEmployee";
import FormacionColaboradorReducer from "./Carrera_Sucesion/PerfilColaborador/PerfilColaborador"
import auroraDivisionReducer from "./auroraDivision/auroraDivision";
import companyResponsibleReducer from "./CompanyResponsibles/CompanyResponsibles";

//Módulo Plan de carrera
import PlanCarreraStatusesReducer from "./planCarrera/Estados/Statuses";
import PlanCarreraPlansReducer from "./planCarrera/Plan/Plans";
import PlanCarreraCoursesReducer from "./planCarrera/Cursos/Courses";
import PlanCarreraCoursesTasksReducer from "./planCarrera/CursosFunciones/CoursesFun";
import PlanCarreraPlanSeguimientoReducer from "./planCarrera/PlanSeguimiento/PlanSeguimiento";
import PlanCarreraCompetenciesReducer  from "./planCarrera/Competencias/Competencies";
import PlanCarreraCompetenciesFunReducer from "./planCarrera/CompetenciasFunciones/CompetenciesFun";
import PlanCarreraPlanIndividualReducer from "./planCarrera/PlanIndividual/PlanIndividual";
import PlanCarreraMapaCarreraReducer from "./planCarrera/MapaCarrera/MapaCarrera";
//Survey
import SurveyTemplateReducer from "./survey/surver_template/surveyTemplate";
import SelectSearchReducer from "./selectSearch/selectSearch";
import surveyTemplateQuestionsReducer from "./survey/surver_template/questions/surveyTemplateQuestions";
//Audiences
import AudiencesActionsReducer from "./Modulo_Sanciones/Audiences/audiences_actions";
import RecidivismActionsReducer from "./Modulo_Sanciones/Recidivism/recidivism_actions";
import surveyUserFormReducer from "./survey/survey_user_form/surveyUserForm";
import surveyResultsReducer from "./survey/survey_results/surveyResults";
// Capacitaciones - Nuevos modulos
import trainingBudgetControl from "./capacitacionDesarrollo/BudgetControl/budgetControlActions";
import CoursesEnrollment from "./capacitacionDesarrollo/Enrollment/enrollmentActions";
import DNC from "./capacitacionDesarrollo/DNC/dncActions";

// Módulo Notificaciones
import NotificationsCollaboratorTypeReducer from "./moduloNotificaciones/tipoColaborador/CollaboratorType";
import NotificationsTypeReducer from "./moduloNotificaciones/tipoNotificacion/NotificationType";
import NotificationBodyReducer from "./moduloNotificaciones/cuerpoNotificacion/NotificationBody";
import NotificationSegmentReducer from "./moduloNotificaciones/segmentoNotificacion/NotificationSegment";
import NotificationVariableReducer from "./moduloNotificaciones/variableNotificacion/NotificationVariable"
import NotificationHistoryReducer from "./moduloNotificaciones/NotificationHistory/NotificationHistory";


const rootReducer = combineReducers({
  auth: authReducer,
  jobPositions: jobPositionsReducer,
  jobs: jobsReducer,
  areas: areasReducer,
  employees: employeesReducer,
  centerCost: centerCostReducer,
  division: divisionReducer,
  civilState: civilStateReducer,
  auroraDivision: auroraDivisionReducer,
  funcTabEmployeed: funcTabEmployeedReducer,
  relatives: relativesReducer,
  relationship: relationshipReducer,
  emergencyContact: emergencyContactReducer,
  orgs: orgsReducer,
  funcStructure: funcStructureReducer,
  beneficers: beneficersReducer,
  equipment: equipmentReducer,
  compania: companiaReducer,
  academicStory: academicStoryReducer,
  specialization: specializationReducer,
  jobStory: jobStoryReducer,
  employmentRelationShipFuncional: employmentRelationShipFuncionalReducer,
  currentSituation: currentSituationReducer,
  orgsPrueba: orgsPruebaReducer,
  institute: instituteReducer,
  collegeDegree: collegeDegreeReducer,
  diagnosis: diagnosisReducer,
  health: healthReducer,
  education: educationReducer,
  divisionPersonal: divisionPersonalReducer,
  funcFormation: funcFormationsReducer,
  employeesHierarchy: employeesHierarchyReducer,
  plazasJefes: plazasJefesReducer,
  userDataUpdate: updateUserDataReducer,
  updateDependantsData: updateDependantsDataReducer,
  checklistDocs: checkListReducer,
  employeeDocsCheckList: employeeDocsCheckListReducer,
  labs: labsReducer,
  vaccines: vaccinesReducer,
  vaccinesEmp: vaccinesEmpReducer,
  adminSettings: adminSettingsReducer,
  measurements: measurementsReducer,
  tasks: tasksReducer,
  classification: classificationReducer,
  category: categoryReducer,
  tool: toolReducer,
  TipoPregunta: preguntaReducer,
  segment: segmentReducer,
  employeesTimes: employeesTimesReducer,
  plantillaCuestionario: plantillaCuestionarioReducer,
  cuestionario: cuestionarioReducer,
  campaña: CAMPAÑAReducer,
  monitor: monitorReducer,
  survey: SurveyReducer,
  reporteLogin: ReporteLoginReducer,
  workflow: workflowReducer,
  workflowBlock: workflowBlockReducer,
  bienvenida: bienvenidaReducer,
  unidadNodes: unidadNodesReducer,
  wflowempleados: WFlowEmpleadosReducer,
  workflowBlockCheckList: workflowBlockCheckListReducer,
  monitorOnBoarding: monitorOnBoarding,
  capacitacion: CapacitacionOnBoardingReducer,
  dashBoardRespBoss: DashBoardRespBossReducer,
  gestorDocumental: gestorDocumentalReducer,
  disciplinaryReason: DisciplinaryReasonReducer,
  disciplinaryMeasurement: DisciplinaryMeasurementReducer,
  unlinkCategories: UnlinkCategoriesReducer,
  disciplinaryActionType: DisciplinaryActionTypesReducer,
  foulType: FoulTypeReducer,
  disciplinaryCase: DisciplinaryCaseReducer,
  sancionesStatus: SancionesStatusReducer,
  disciplinaryActions: DisciplinaryActionsReducer,
  unlinkTemplates: UnlinkTemplatesReducer,
  sancionesDocs: SancionesDocsReducer,
  casualtyMonitor: CasualtyMonitorReducer,
  competencies: CompetenciesReducer,
  areasDescriptoresPerfiles: AreasReducer,
  descCompetencies: DescCompetenciesReducer,
  competenciesType: CompetenciesTypeReducer,
  measurementUnit: MeasurementUnitReducer,
  politicsAndProcedure: PoliticsAndProceduresReducer,
  purpose: PurposeReducer,
  competenciesDesc: CompetenciesDescReducer,
  generalInfo: GeneralInfoReducer,
  titles: TitlesReducer,
  knowledgeAreas: KnowledgeAreasReducer,
  educationLevel: EducationLevelReducer,
  course: CourseReducer,
  technicalKnowledge: TechnicalKnowledgeReducer,
  mantIndk: MantIndkReducer,
  generalData: generalData,
  jobFunction: JobFunctionReducer,
  indikators: IndikatorsReducer,
  preparation: PreparationReducer,
  training: TrainingReducer,
  technicalKnowledgeAcquired: TechnicalKnowledgeAcquiredReducer,
  experience: ExperienceReducer,
  assignCompetencies: AssignCompetenciesReducer,
  plazasVacantes: PlazasVacantesReducer,
  estados: EstadosReducer,
  motivos: MotivosReducer,
  paises: PaisesReducer,
  competenciesTotal: CompetenciesTotalReducer,
  requirementsMonitor: RequirementsMonitorReducer,
  dashBoardSelect: DashBoardSelectReducer,
  requestTracking: RequestTrackingReducer,
  evaluationType: EvaluationTypeReducer,
  periodoEvaluacion: PeriodoEvaluacionReducer,
  dashBoardSelectContrataciones: DashBoardSelectContratacionesReducer,
  dashBoardSelectVacantes: DashBoardSelectVacantesReducer,
  metricByFactor: MetricByFactorReducer,
  factor: FactorReducer,
  factorQuestion: FactorQuestionReducer,
  factorTemplate: FactorTemplateReducer,
  planAccion: PlanAccionReducer,
  categoriaDesempenio: CategoriaDesempenioReducer,
  periodicity: PeriodicityReducer,
  metricaCompetencia: MetricaCompetenciaReducer,
  periodConfig: PeriodConfigReducer,
  pesoCompetencia: PesoCompetenciaReducer,
  plantillaCompetencia: PlantillaCompetenciaReducer,
  evaluationMonitor: EvaluationMonitorReducer,
  competencyQuestion: CompetencyQuestionReducer,
  evalFormCompetency: EvalFormCompetencyReducer,
  employeeMonitor: EmployeeMonitorReducer,
  evalFormCompetencyQuestion: EvalFormCompetencyQuestionReducer,
  overview: OverviewReducer,
  evalFormFactor: EvalFormFactorReducer,
  notifications: NotificationsReducer,
  dashboardJefe: DashboardJefeReducer,
  modalities: ModalitiesReducer,
  trainingType: TrainingTypeReducer,
  origins: OriginsReducer,
  reasonsForAbsence: ReasonsForAbsenceReducer,
  trainings: TrainingsReducer,
  matrixNineBoxes: MatrixNineBoxesReducer,
  status: StatusReducer,
  metricNineBoxesReduce: MetricNineBoxesReducer,
  formalEducationMetrics: FormalEducationMetricsReducer,
  metricEvaluationFactor: MetricEvaluationFactorReducer,
  metricNineBoxes: MetricNineBoxesReducer,
  metricJobExperience: MetricJobExperienceReducer,
  approaches: ApproachesReducer,
  campaigns: CampaignsReducer,
  trainingEvents: TrainingEventsReducer,
  employeeMonitorCapacitation: EmployeeMonitorCapacitationReducer,
  trainingAssistance: TrainingAssistanceReducer,
  detailTraining: DetailTrainingReducer,
  nineBoxes: NineBoxesReducer,
  countryUser: CountryUserReducer,
  departamentUser: DepartamentUserReducer,
  municipalityUser: MunicipalityUserReducer,
  holiday: HolidayReducer,
  jobpositionRelated: JobpositionRelatedReducer,
  factorName: FactorNameReducer,
  formEvalCapa: FormEvalCapaReducer,
  positionHistory: PositionHistoryReducer,
  evaluationAccept: EvaluationAcceptReducer,
  workflowTaskList: WorkflowTaskListReducer,
  excelMassiveUpload: ExcelMassiveUploadReducer,
  descriptorValidation: descriptorValidationReducer,
  criteriosEvaluador: CriteriosEvaluadorReducer,
  collaboratorsEvaluate: CollaboratorsEvaluateReducer,
  sessionNotification: SessionNotificationReducer,
  activoFijo: ActivoFijoReducer,
  excelUpload: ExcelUploadReducer,
  climaLog: ClimaLogReducer,
  goalPerYear: GoalPerYearReducer,
  tipoCriticidad: TipoCriticidadReducer,
  cursos : CursosReducer,
  cursosFuncion : CursosFuncionReducer,
  criticidad: CriticidadReducer,
  factoresCriticidad: FactoresCriticidadReducer,
  matrizEvaluacionPuesto: MatrizEvaluacionPuestoReducer,
  authBoaring: authBoarningReducer,
  matrizSucesion: MatrizSucesionReducer,
  evaluableEmployeeMonitor: EvaluableEmployeeMonitorReducer,
  employeesVacations: EmployeesVacationsReducer,
  calendarEmployeeEvents: CalendarEmployeeEventsReducer,
  calendarHolidays: CalendarHolidaysReducer,
  criterion: CriteriosReducer,
  factorCriterion: FactoresCriteriosReducer,
  responsibleFactor: FactoresResponsablesReducer,
  descriptorFactorCriterion: DescriptorFactoresCriterios,
  planCarreraIndividual: PlanCarreraIndividualReducer,
  scheduleTrackingPlannedVacationsEmployee: ScheduleTrackingPlannedVacationsEmployeeReducer,
  formacionColaborador: FormacionColaboradorReducer,
  companyResponsible : companyResponsibleReducer,
  planCarreraStatus: PlanCarreraStatusesReducer,
  planCarreraPlan: PlanCarreraPlansReducer,
  planCarreraCourse: PlanCarreraCoursesReducer,
  planCarreraCoursesTasks : PlanCarreraCoursesTasksReducer,
  planCarreraPlanSeguimiento: PlanCarreraPlanSeguimientoReducer,
  planCarreraCompetency: PlanCarreraCompetenciesReducer,
  planCarreraCompetenciesFun : PlanCarreraCompetenciesFunReducer,
  planCarreraPlanIndividual: PlanCarreraPlanIndividualReducer,
  planCarreraMapaCarrera : PlanCarreraMapaCarreraReducer,
  surveyTemplate: SurveyTemplateReducer,
  selectSearch: SelectSearchReducer,
  surveyTemplateQuestions: surveyTemplateQuestionsReducer,
  audiencesActions: AudiencesActionsReducer,
  recidivismActions: RecidivismActionsReducer,
  surveyUserForm: surveyUserFormReducer,
  surveyResults: surveyResultsReducer,
  surveyResults: surveyResultsReducer,
  trainingBudgetControl: trainingBudgetControl,
  CoursesEnrollment: CoursesEnrollment,
  DNC: DNC,
  notificationsCollaboratorType: NotificationsCollaboratorTypeReducer,
  notificationsType: NotificationsTypeReducer,
  notificationBody: NotificationBodyReducer,
  notificationSegment: NotificationSegmentReducer,
  notificationVariable: NotificationVariableReducer,
  notificationHistory: NotificationHistoryReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function generateStore() {
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
  );
  return store;
}
